<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Create Domain" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="create()" ngNativeValidate>
          <app-domain-form [domain]="domain" *ngIf="domain"></app-domain-form>
        </form>
      </div>
    </section>
  </div>
</div>


